import { TANI_PROJECTS, TANI_SESSIONS } from '../actions/taniSessionsActions'

export const initialValue = {
  allTaniSessions: {},
  allTaniProjects: {}
}

const taniState = (state = {}, action) => {
  const { type, payload } = action
  switch (type) {
    case TANI_SESSIONS:
      const newSession = { ...state.allTaniSessions, ...payload }
      return { ...state, allTaniSessions: newSession }
    case TANI_PROJECTS:
      const projectSession = { ...state.allTaniProjects, ...payload }
      return { ...state, allTaniProjects: projectSession }
    default:
      return state
  }
}

export default taniState



// WEBPACK FOOTER //
// ../src/reducers/taniState.js